var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.aiDropdownVisible
        ? _c("div", {
            staticClass: "ai-backdrop",
            on: {
              click: function ($event) {
                _vm.aiDropdownVisible = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "top-toolbox" },
        [
          _vm.filteredChatbotStoryViewActivity.length > 0
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        content: _vm.onlineUsersTooltip,
                        placement: "bottom",
                      },
                      expression:
                        "{ content: onlineUsersTooltip, placement: 'bottom' }",
                    },
                  ],
                  staticClass: "online-users-pill",
                },
                [
                  _c("span", { staticClass: "online-pulse-dot" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "online-count" }, [
                    _vm._v(_vm._s(_vm.filteredChatbotStoryViewActivity.length)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "online-label" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.online"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.filteredChatbotStoryViewActivity.length > 0
            ? _c("div", { staticClass: "toolbox-divider" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "chatbot-btn",
              class: { selected: _vm.bar === 1 },
              attrs: { disabled: _vm.previewMode },
              on: {
                click: function ($event) {
                  return _vm.toggleBar(1)
                },
              },
            },
            [_c("md-icon", [_vm._v("bolt")])],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "chatbot-btn",
              class: { selected: _vm.bar === 6 },
              on: {
                click: function ($event) {
                  return _vm.toggleBar(6)
                },
              },
            },
            [_c("md-icon", [_vm._v("electrical_services")])],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "chatbot-btn",
              class: { selected: _vm.bar === 8 },
              attrs: { disabled: _vm.previewMode },
              on: {
                click: function ($event) {
                  return _vm.toggleBar(8)
                },
              },
            },
            [_c("md-icon", [_vm._v("image")])],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "chatbot-btn",
              class: { selected: _vm.bar === 2 },
              attrs: { disabled: _vm.previewMode },
              on: {
                click: function ($event) {
                  return _vm.toggleBar(2)
                },
              },
            },
            [_c("md-icon", [_vm._v("search")])],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { content: _vm.$t("chatbotv2.cacheManagement") },
                  expression: "{ content: $t('chatbotv2.cacheManagement') }",
                },
              ],
              staticClass: "chatbot-btn",
              class: { selected: _vm.bar === 9 },
              attrs: { disabled: _vm.previewMode },
              on: {
                click: function ($event) {
                  return _vm.toggleBar(9)
                },
              },
            },
            [_c("md-icon", [_vm._v("storage")])],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "chatbot-btn",
              class: { selected: _vm.bar === 3 },
              attrs: { disabled: _vm.previewMode },
              on: {
                click: function ($event) {
                  return _vm.toggleBar(3)
                },
              },
            },
            [_c("md-icon", [_vm._v("settings")])],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "chatbot-btn",
              class: { selected: _vm.bar === 4 },
              on: {
                click: function ($event) {
                  return _vm.toggleBar(4)
                },
              },
            },
            [_c("md-icon", [_vm._v("history")])],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "primary", ghost: "" },
              on: {
                click: function ($event) {
                  return _vm.toggleBar(5)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("chatbotv2.testBot")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.debugMode
            ? _c(
                "button",
                {
                  staticClass: "chatbot-btn",
                  class: { selected: _vm.bar === 7 },
                  attrs: { disabled: _vm.previewMode },
                  on: {
                    click: function ($event) {
                      return _vm.toggleBar(7)
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: "/static/img/copilot.png",
                      width: "16",
                      height: "16",
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ai-btn-container" },
            [
              _c("div", { staticClass: "ai-btn-group" }, [
                _c(
                  "button",
                  {
                    staticClass: "ai-main-btn",
                    on: {
                      click: function ($event) {
                        return _vm.openAIPanel("settings")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons ai-sparkle-icon" }, [
                      _vm._v("auto_awesome"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ai-btn-label" }, [_vm._v("AI")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ai-chevron-btn",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        _vm.aiDropdownVisible = !_vm.aiDropdownVisible
                      },
                    },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons ai-chevron-icon",
                        class: { rotated: _vm.aiDropdownVisible },
                      },
                      [_vm._v("expand_more")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "ai-dropdown" } }, [
                _vm.aiDropdownVisible
                  ? _c("div", { staticClass: "ai-dropdown-menu" }, [
                      _c(
                        "div",
                        {
                          staticClass: "ai-dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.openAIPanel("files")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("folder_open"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.knowledgeBase"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ai-dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.openAIPanel("functions")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("functions"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.aiFunctions"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ai-dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.openAIPanel("rag-settings")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("tune"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.ragSettings"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ai-dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.openAIPanel("ai-models")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("psychology"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.aiModels"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ai-dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.openAIPanel("plugins")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("extension"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.plugins"))),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "ai-dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.openAIPanel("settings")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("edit_note"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.promptSettings"))),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.checkPermission(
            _vm.PERMISSION_TYPES["chatbot.stories.update"].tr.name
          )
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary", disabled: _vm.previewMode },
                  on: {
                    click: function ($event) {
                      _vm.versionModal = true
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-flex justify-content-between align-content-center align-items-center",
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("send"),
                      ]),
                      _vm._v(" "),
                      _c("b", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.publish"))),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.bar !== 0
        ? _c(
            "div",
            { staticClass: "side-bar" },
            [
              _vm.bar === 1
                ? _c("ActionPalette", {
                    attrs: {
                      dragMode: _vm.dragMode,
                      dragStart: _vm.dragStart,
                      dragEnd: _vm.dragEnd,
                      addBlockToDiagram: _vm.addBlockToDiagram,
                      bar: _vm.bar,
                    },
                    on: {
                      "close-menu": function ($event) {
                        _vm.bar = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.previewMode && _vm.bar === 2
                ? _c("SearchWidget", {
                    attrs: {
                      blocksMetas: _vm.blocksMetas,
                      flattedDiagram: _vm.flattedDiagram,
                      toggleBar: _vm.toggleBar,
                      bar: _vm.bar,
                      board: _vm.board,
                      navigateTo: _vm.navigateTo,
                    },
                    on: {
                      focusBlock: _vm.focusBlock,
                      "close-menu": function ($event) {
                        _vm.bar = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.previewMode && _vm.bar === 3
                ? _c("SettingsWidget", {
                    attrs: {
                      bar: _vm.bar,
                      diagram: _vm.diagram,
                      "story-id": _vm.storyId,
                      board: _vm.board,
                    },
                    on: {
                      "close-menu": function ($event) {
                        _vm.bar = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.bar === 4
                ? _c("VersionSwitcher", {
                    attrs: { "story-id": _vm.storyId, bar: _vm.bar },
                    on: {
                      "close-menu": function ($event) {
                        _vm.bar = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.bar === 5
                ? _c("ChatWidget", {
                    attrs: {
                      "story-id": _vm.storyId,
                      version: _vm.version,
                      "test-start-block-id": _vm.testStartBlockId,
                      diagram: _vm.diagram,
                    },
                    on: {
                      "close-menu": function ($event) {
                        _vm.bar = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.bar === 6
                ? _c("AddIntergation", {
                    attrs: { storyId: _vm.storyId },
                    on: {
                      "close-menu": function ($event) {
                        _vm.bar = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.bar === 7 && _vm.debugMode
                ? _c("ChatbotAgent", {
                    attrs: {
                      storyId: _vm.storyId,
                      version: _vm.version,
                      bar: _vm.bar,
                    },
                    on: {
                      "close-menu": function ($event) {
                        _vm.bar = $event
                      },
                      "diagram-updated": _vm.handleDiagramUpdate,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.bar === 8
                ? _c("ImageProcessingModal", {
                    attrs: { storyId: _vm.storyId },
                    on: {
                      close: function ($event) {
                        _vm.bar = 0
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.bar === 9
                ? _c("CacheWidget", {
                    attrs: { "story-id": _vm.storyId },
                    on: {
                      "close-menu": function ($event) {
                        _vm.bar = $event
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            id: "publish-modal",
            title: _vm.$t("chatbotv2.newVersion"),
            wrapClassName: "vertical-center-modal",
            okText: _vm.$t("message.ok"),
            cancelText: _vm.$t("message.cancel"),
          },
          on: {
            ok: _vm.publishHandler,
            cancel: function ($event) {
              _vm.versionModal = false
            },
          },
          model: {
            value: _vm.versionModal,
            callback: function ($$v) {
              _vm.versionModal = $$v
            },
            expression: "versionModal",
          },
        },
        [
          _c(
            "a-form",
            {
              staticClass: "d-flex flex-column justify-content-center",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.publishHandler.apply(null, arguments)
                },
              },
            },
            [
              _c("a-input", {
                attrs: {
                  value: _vm.$route.params.version,
                  placeholder: "1.0",
                  disabled: "disabled",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }